import React, { Component } from "react";

import "../App.css";
import "../css/style.css";
import "../css/bootstrap.css";
import logo from "../Assets/mathisadmission.png";

class Division extends Component {
  constructor(props) {
    super(props);
    this.state = {
      quotient: Math.floor(Math.random() * 30) + 1,
      number: Math.floor(Math.random() * 1000) + 1,
      answer: "",
      min: 2,
      maxquotient: 30,
      maxNumber: 1000,
      result: 0,
      message: "C'est parti!",
      messageColor: "black-message",
    };
  }

  mySubmitHandlerOperation = (event) => {
    event.preventDefault();
    var good = parseFloat((this.state.number / this.state.quotient).toFixed(2));
    if (Number(this.state.answer) === good) {
      this.setState({ messageColor: "green-message" });
      this.setState({
        message:
          "Correct : " +
          this.state.number +
          "/" +
          this.state.quotient +
          " = " +
          good,
      });
    } else {
      this.setState({ messageColor: "red-message" });
      this.setState({
        message:
          "Erreur : " +
          this.state.number +
          "/" +
          this.state.quotient +
          " = " +
          good,
      });
    }
    var pourcent =
      Math.floor(
        Math.random() * (Number(this.state.maxquotient) - Number(this.state.min) + 1)
      ) + Number(this.state.min);
    var num =
      Math.floor(
        Math.random() * (Number(this.state.maxNumber) - Number(this.state.min) + 1)
      ) + Number(this.state.min);
    var res = parseFloat((this.state.number / this.state.quotient).toFixed(2))
    this.setState({ quotient: pourcent, number: num, result: res, answer: ""});
  };

  myChangeHandler = (event) => {
    this.setState({ answer: event.target.value });
  };

  // componentDidMount() {
  //
  // }

  render() {
    return (
      <div className="App">
        <div className="navigation">
          <img
            className="website-logo"
            src={logo}
            alt="Logo Mathis Admission"
          />
          <h1 className="website-title-text">Prepa Tage Mage</h1>
        </div>

        <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
          <div className="col">
            <h2 className="menu-principal-text">Division</h2>
          </div>
        </div>

        <div className="container">
          <p>Donnez le résultat arrondi 2 chiffres après la virgule</p>
          <p>Exemple : 53.235&nbsp;=&nbsp;53.24 | 74.312&nbsp;=&nbsp;74.31 | 40.20&nbsp;=&nbsp;40.2 | 78.00&nbsp;=&nbsp;78</p>
          <form
            className="col"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
            onSubmit={this.mySubmitHandlerOperation}
          >
            <p
              className={this.state.messageColor}
              style={{ marginTop: 40, marginBottom: 20 }}
            >
              {this.state.message}
            </p>
            <div className="row">
              <label className="label-exos">
                {this.state.number} / {this.state.quotient} = ?
              </label>
            </div>
            <input
              className="input-square"
              type="float"
              name="answer"
              value={this.state.answer} 
              onChange={this.myChangeHandler}
            />
            <input
              className="validate-button"
              style={{ backgroundColor: "#00cfa4" }}
              type="submit"
              value="Valider"
            />
          </form>
        </div>

        <div className="row" style={{ marginTop: 40, marginBottom: 40 }}>
          <div className="col-12 col-lg-4">
            <a className="all-button" href="/">
              Retour au menu
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default Division;
